import { Component, OnInit } from '@angular/core';
import { Router }              from '@angular/router';
import { FormDataService } from '../service/form/form-data.service';
import { CookiesLocalService } from '../service/cookies-local.service';
import { IApplicant } from '../model/IApplicant';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.css']
})
export class InstructionComponent implements OnInit {

title="Instructions for the Online Admission System.";
  applicantData: IApplicant;

    constructor(private router: Router,
      private formDataService: FormDataService,
      private cookieLocal:CookiesLocalService) {
    }


  ngOnInit() {
    this.applicantData=this.cookieLocal.getApplicantData();

  }

 goToNext() {
        this.router.navigate(['/applicant/choose-campus']);

    }
}
